import resolveFunctionSchemas from '../resolveFunctionSchemas';

export default Form => props => <Form {...resolveFunctionSchemas(props)} />;
